export function getGenderFromNir(nir: string) {
  switch (nir.charAt(0)) {
    case '1':
      return 'M'
    case '2':
      return 'F'
    default:
      return 'I'
  }
}
